import { render } from "./CreateCollectionOrderModal.html?vue&type=template&id=5a996ea6&scoped=true"
import script from "./CreateCollectionOrderModal.js?vue&type=script&lang=js"
export * from "./CreateCollectionOrderModal.js?vue&type=script&lang=js"

import "./CreateCollectionOrderModal.css?vue&type=style&index=0&id=5a996ea6&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a996ea6"]])

export default __exports__